import { Routes } from '@angular/router';

// import leadersRoutes from './modules/leaders/leaders.routes';
import { NotFoundComponent } from './shell/components/not-found/not-found.component';
import { WrapperComponent } from './shell/components/wrapper/wrapper.component';
import mainRoutes from './modules/main/main.routes';
import crashRoutes from './modules/crash/crash.routes';
import jackpotRoutes from './modules/jackpot/jackpot.routes';
import wheelRoutes from './modules/wheel/wheel.routes';
import doubleRoutes from './modules/double/double.routes';
import bonusesRoutes from './modules/bonuses/bonuses.routes';
import supportRoutes from './modules/support/support.routes';
import vipRoutes from './modules/vip/vip.routes';
import provablyFairRoutes from './modules/provably-fair/provably-fair.routes';
import minesRoutes from './modules/mines/mines.routes';
import paymentRoutes from './modules/payment/payment.routes';
import defuseRoutes from './modules/defuse/defuse.routes';
import usersRoutes from './modules/users/users.routes';
import referralsRoutes from './modules/referrals/referrals.routes';
import promoRoutes from './modules/promo/promo.routes';
import bonusWheelRoutes from './modules/bonus-wheel/bonus-wheel.routes';
import superWheelRoutes from './modules/super-wheel/super-wheel.routes';
import landingRoutes from './modules/landing/landing.routes';
import historyRoutes from './modules/history/history.routes';
import rafflesRoutes from './modules/raffles/raffles.routes';
import gamesRoutes from './modules/games/games.routes';

export const routes: Routes = [
  {
    path: '',
    component: WrapperComponent,
    children: mainRoutes
  },
  {
    path: 'crash',
    component: WrapperComponent,
    children: crashRoutes
  },
  {
    path: 'jackpot',
    component: WrapperComponent,
    children: jackpotRoutes
  },
  {
    path: 'wheel',
    component: WrapperComponent,
    children: wheelRoutes
  },
  {
    path: 'double',
    component: WrapperComponent,
    children: doubleRoutes
  },
  {
    path: 'bonuses',
    component: WrapperComponent,
    children: bonusesRoutes
  },
  {
    path: 'support',
    component: WrapperComponent,
    children: supportRoutes
  },
  {
    path: 'vip',
    component: WrapperComponent,
    children: vipRoutes
  },
  {
    path: 'provably-fair',
    component: WrapperComponent,
    children: provablyFairRoutes
  },
  {
    path: 'mines',
    component: WrapperComponent,
    children: minesRoutes
  },
  // {
  //   path: 'cards',
  //   component: WrapperComponent,
  //   children: eventRoutes
  // },
  // {
  //   path: 'top',
  //   component: WrapperComponent,
  //   children: leadersRoutes
  // },
  {
    path: 'bonus-wheel',
    component: WrapperComponent,
    children: bonusWheelRoutes
  },
  {
    path: 'crazy-wheel',
    component: WrapperComponent,
    children: superWheelRoutes
  },
  {
    path: 'payment',
    component: WrapperComponent,
    children: paymentRoutes
  },
  {
    path: 'defuse',
    component: WrapperComponent,
    children: defuseRoutes
  },
  /* {
    path: 'battleship',
    component: WrapperComponent,
    children: battleshipRoutes
  }, */
  {
    path: 'profile',
    component: WrapperComponent,
    children: usersRoutes
  },
  {
    path: 'pvp-battle',
    redirectTo: ''
  },
  {
    path: 'raffles',
    component: WrapperComponent,
    children: rafflesRoutes
  },
  // {
  //   path: 'tournaments',
  //   component: WrapperComponent,
  //   children: tournamentsRoutes
  // },
  {
    path: 'auth/oauth',
    component: WrapperComponent,
    children: [
      {
        path: '',
        loadComponent: async () => import('./modules/users/components/oauth-page/oauth-page.component')
      }
    ]
  },
  {
    path: 'm/:code',
    loadComponent: async () => import('./modules/users/components/marketing-redirect/marketing-redirect.component')
  },
  {
    path: 'r/:code',
    loadComponent: async () => import('./modules/referrals/components/redirect/redirect.component')
  },
  {
    path: 'referrals',
    component: WrapperComponent,
    children: referralsRoutes
  },
  {
    path: '',
    children: promoRoutes
  },
  {
    path: 'landing',
    children: landingRoutes
  },
  {
    path: 'landing2',
    children: landingRoutes
  },
  {
    path: 'pickem-austin-major-2025',
    redirectTo: ''
  },
  {
    path: 'technical-work',
    loadComponent: async () => import('./modules/technical-work/technical-work.component')
  },
  {
    path: 'history',
    component: WrapperComponent,
    children: historyRoutes
  },
  {
    path: 'games',
    component: WrapperComponent,
    children: gamesRoutes
  },
  {
    path: '**',
    component: NotFoundComponent
  }
];
